import { render, staticRenderFns } from "./usuarioAsignatura.vue?vue&type=template&id=144a2dbc"
import script from "./usuarioAsignatura.vue?vue&type=script&lang=js"
export * from "./usuarioAsignatura.vue?vue&type=script&lang=js"
import style0 from "./usuarioAsignatura.vue?vue&type=style&index=0&id=144a2dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports